import { theme } from '../../Assets/Styles/theme'

export const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  smallWrapper: {
    minWidth: 80,
    maxWidth: 80,
    fontSize: 14,
  },
  disabledWrapper: {
    color: '#FFFFFF',
    backgroundColor: '#C2C8D1',
    borderRadius: 10,
    minWidth: 150,
    maxWidth: 300,
    height: 44,
  },
  outlinedWrapper: {
    border: `2px solid ${theme.colors.primary}`,
    borderRadius: 10,
    minWidth: 150,
    maxWidth: 300,
    transition: 'all 0.3s',
    cursor: 'pointer',
    height: 44,
    '&:hover': {
      backgroundColor: theme.colors.primary,
      color: 'white',
    },
  },
  filledWrapper: {
    borderRadius: 10,
    backgroundColor: theme.colors.primary,
    color: 'white',
    minWidth: 150,
    maxWidth: 300,
    transition: 'all 0.3s',
    cursor: 'pointer',
    height: 44,
    '&:hover': {
      opacity: 0.8,
    },
  },
  textTypeWrapper: {
    color: theme.colors.primary,
    minWidth: 150,
    maxWidth: 300,
    transition: 'all 0.3s',
    cursor: 'pointer',
    height: 44,
    '&:hover': {
      opacity: 0.8,
    },
  },
  underline: {
    borderBottom: '2px solid #0f3170',
    cursor: 'pointer',
    height: 44,
    transition: 'all 0.3s',
    width: 'fit-content',
    '&:hover': {
      opacity: 0.8,
      backgroundColor: 'white',
    },
  },
  buttonContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
  },
  icon: {
    marginRight: 8,
  },
  title: {
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '700',
  },
  loader: {
    marginTop: 6,
  },
}
